import script from "./InvoiceSalesOfferTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSalesOfferTable.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSalesOfferTable.vue?vue&type=style&index=0&id=3c5ed7d6&lang=css"

const __exports__ = script;

export default __exports__